import { inject, Injectable } from "@angular/core";
import { AssetService } from "../asset/asset.service";
import { ASSET_TYPES } from "../../../enums/assetTypes.enum";
import { map, Observable } from "rxjs";
import { StatusTableRow } from "../../../models/ui/statusTableRow";
import { transformManufacturerName } from "../../../shared/utils/utils";
import { SEVERITY } from "../../../constants/severities";

@Injectable({
  providedIn: "root",
})
export class GateStatusService {
  private assetService = inject(AssetService);

  /**
   * Fetches the gate status for the given parent asset.
   * @param parentId the id of the parent asset
   * @param parentType the type of the parent asset
   * @returns an observable of StatusTableRow[]
   */
  public getAssetStatus(parentId: string, parentType: string): Observable<StatusTableRow[]> {
    const repairRelevantSeverity: string[] = [SEVERITY.MAJOR.status, SEVERITY.CRITICAL.status];

    return this.assetService.getAssets(ASSET_TYPES.GATE_SYSTEM, parentId, parentType, true).pipe(
      map((assets) => {
        return assets.reduce((acc: StatusTableRow[], asset) => {
          if (asset.id) {
            acc.push({
              id: asset.id,
              severity: asset?.severity,
              label: asset?.label,
              coreId: asset?.coreId,
              gateType: asset?.gateType?.label,
              gateMake: asset?.gateMake,
              retailerNumber: asset?.retailerNumber,
              gateNumber: asset?.gateNumber,
              gateSystem: asset?.gateSystem,
              gateManufacturer: asset?.gateManufacturer,
              controlManufacturer: transformManufacturerName(asset?.controlManufacturer?.label),
              repairStatus:
                asset?.severity && repairRelevantSeverity.includes(asset?.severity) ? asset.repairStatus : "",
              controlModel: asset?.controlModel?.label,
              cycle: asset?.loadChanges,
              gate_full_cycles: asset?.loadCycles,
            });
          }
          return acc;
        }, []);
      })
    );
  }
}
